<template>
  
  <div>
    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('SENDOUT_TEMPLATE.CREATE')"
        variant="primary"
        @click="create_clicked"
      />
    </div>

    <m-row>
      <m-col cols="6" >
        
        <div class="bottom-alignment">
          <strong>{{ $t('MEMBER.NUM_ROWS') }}:</strong> {{ total_rows }}
        </div>

      </m-col>
      <m-col cols="6">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
            aria-controls="advance-file-table"
          />

        </div>
      </m-col>
    </m-row>
    
    <memlist-static-table
      id="advance-file-table"
      :fields="headers"
      :items="items"
      :per_page="per_page"
      :current_page="current_page"
      :sort-desc="true"
    >
      <template #head(type)="data">
        <tip-label :tip="$t('SENDOUT_TEMPLATE.TYPE')">{{ data.label }}</tip-label>
      </template>

      <template #head(created_at)="data">
        <tip-label :tip="$t('SENDOUT_TEMPLATE.CREATED_AT')">{{ data.label }}</tip-label>
      </template>

      <template #cell(is_active)="row">
        <memlist-badge status="success" v-if="row.item.is_active">{{ $t('SENDOUT_TEMPLATE.ACTIVE') }}</memlist-badge>
        <memlist-badge status="danger" v-else>{{ $t('SENDOUT_TEMPLATE.NOT_ACTIVE') }}</memlist-badge>
      </template>

      <template #cell(id)="row">
        <div class='d-flex justify-content-end'>
          <memlist-table-button class="mr-3" @click="select_clicked(row.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
          <memlist-table-button @click="delete_clicked(row.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
        </div>
      </template>
    </memlist-static-table>
      
  </div>
</template>

<script>

import TipLabel from '@/view/components/TipLabel.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import dayjs from 'dayjs';

export default {
  name: 'SendoutTemplateTable',
  props: ['items', 'currentCompanyId'],
  emits: ['create_clicked','select_clicked','delete_clicked'],
  mixins: [ toasts ],
  components: { TipLabel },
  computed: {
    total_rows() {
      return this.items.length;
    }
  },
  methods: {
    create_clicked() {
      this.$emit('create_clicked');
    },
    select_clicked(template) {
      this.$emit('select_clicked', template);
    },
    delete_clicked(template) {
      this.$emit('delete_clicked', template);
    },
  },
  data() {
    return {
      current_page: 1,
      per_page: 100,
      options: [100, 150, 200],
      headers: [
        {
          key: 'type',
          label: this.$t('SENDOUT_TEMPLATE.TYPE'),
          sortable: true,
          thClass: '',
          tdClass: 'td-contain',
          formatter: (_, __, item) => {
            return  this.$t('TEMPLATE.SENDOUT_TEMPLATES.'+item.type);
          }
        },
        
        {
          key: 'is_active',
          label: this.$t('SENDOUT_TEMPLATE.IS_ACTIVE'),
          sortable: true,
          tdClass: 'td-short3',
          thClass: 'td-short3',
        },
        {
          key: 'created_at',
          label: this.$t('SENDOUT_TEMPLATE.CREATED_AT'),
          sortable: true,
          thClass: 'w-150px',
          formatter: (_, __, item) => {
            return dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss');
          }
        },
        
        {
          key: 'id',
          label: this.$t('PAGES.FILES.HANDLE'),
          thClass: 'w-150px pr-22'
        }
      ],
      list: []
    };
  }
};
</script>
